module.exports = __webpack_public_path__ + "img/icon_benefit-holidays.381700ae.svg";